import { useMemo } from 'react';

export type ModifierLabel = '⌘' | 'Ctrl';

export function useShortcutModifier(): ModifierLabel {
  return useMemo(() => {
    if (typeof navigator === 'undefined') return 'Ctrl';
    const isMac = /Mac|iPhone|iPad|iPod/.test(navigator.platform);
    return isMac ? '⌘' : 'Ctrl';
  }, []);
}
